import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { ProductStack } from './ProductStack';

/** Checkout de ImpulTienda (la tienda DPS66 todavía no está creada: confirmar el subdominio). */
const CHECKOUT_URL = 'https://ice-machine-diagnostic-pro.impultienda.ar/checkout';
const included = ['6 complete volumes, ~300 landscape pages', '124 Field Procedure Cards (FPC 01–124)', '38 ready-to-use worksheets (WS-01–38)', '5 instant-use bonuses', '6 pocket field cards for the van', 'Lifetime access to your files'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="grid-light w-full bg-paper-dark text-pine" data-id="element-234" data-mp="25tsmwopphyuk">
      <div className="mx-auto max-w-2xl px-5 py-14 sm:py-20" data-id="element-235" data-mp="3h7egcm2lmmlw">
        <div className="text-center" data-id="element-236" data-mp="3h5jsayw16edl">
          <p className="eyebrow text-ember-deep" data-id="element-237" data-mp="3c8jvzfozgpzo">Complete package</p>
          <h2 id="pricing-heading" className="rule-underline mt-3 font-display text-[34px] uppercase leading-tight text-pine sm:text-6xl" data-id="element-238" data-mp="3cae8c5m6v9s5">
            Everything for the call, start to finish
          </h2>
        </div>

        <div className="mt-8 overflow-hidden rounded-3xl border border-paper-dark bg-white shadow-card" data-id="element-239" data-mp="9ta4la252gry">
          <div className="bg-forest-deep px-5 py-5 text-center" data-id="element-240" data-mp="eqabfn6tbnk4">
            <h3 className="font-display text-2xl uppercase text-paper sm:text-3xl" data-id="element-241" data-mp="3d97i9szie6v1">
              Ice Machine Diagnostic Pro — Complete Package
            </h3>
            <p className="mt-1 text-[13px] font-bold text-ember" data-id="element-242" data-mp="3i8bny9n85mgm">
              6 Volumes + 5 Bonuses
            </p>
          </div>

          <div className="p-5 sm:p-7" data-id="element-243" data-mp="3rxlh7stt1b6b">
            <div className="grid-dark rounded-2xl bg-forest-deep px-3 pb-4 pt-5" data-id="element-244" data-mp="3ryn5x03qtw6i">
              <ProductStack data-id="element-245" data-mp="2uj9919jz67pt" />
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-246" data-mp="2ugdabj0azf0b">
              {included.map(item => <li key={item} className="flex items-start gap-2 text-[15px]" data-id="element-247" data-mp="2zf7sciqg4zjd">
                  <span className="mt-0.5 flex h-[18px] w-[18px] flex-none items-center justify-center rounded-full bg-sky-soft" data-id="element-248" data-mp="2rf1t7yr2rc5q">
                    <CheckIcon className="h-3 w-3 text-sky-deep" aria-hidden="true" data-id="element-249" data-mp="316oaocu0a7gx" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <div className="mt-7 border-t border-paper-dark pt-6 text-center" data-id="element-250" data-mp="2w9xl8ywb9ziu">
              <p className="text-[13px] text-pine-soft" data-id="element-251" data-mp="28i8xlvufpz88">
                Regular price{' '}
                <span className="text-pine-muted line-through" data-id="element-252" data-mp="23kgz2izabev2">$69 USD</span>
              </p>
              <div className="mt-1 flex items-start justify-center gap-1" data-id="element-253" data-mp="2ihrhkcachl0a">
                <span className="mt-2.5 font-display text-4xl" data-id="element-254" data-mp="2dg23sovqmt8i">$</span>
                <span className="font-display text-7xl leading-[0.9] sm:text-8xl" data-id="element-255" data-mp="3tv3c1wk7sr9s">
                  27
                </span>
                <span className="mt-3 text-[13px] font-bold text-pine-muted" data-id="element-256" data-mp="3ov781xbiozu8">
                  USD
                </span>
              </div>

              <div className="mt-3 flex flex-wrap justify-center gap-2" data-id="element-257" data-mp="cglw5hup72i">
                <span className="rounded border border-ember bg-ember px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine" data-id="element-258" data-mp="5a9sgzn2g33b">
                  Save $42
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-259" data-mp="3rhgaldfcnrr4">
                  One-time payment
                </span>
                <span className="rounded border border-paper-dark px-2.5 py-1 text-[10px] font-bold uppercase tracking-widest text-pine-soft" data-id="element-260" data-mp="nyn2hg5cbv4c">
                  Lifetime access
                </span>
              </div>

              <p className="mt-4 text-sm text-pine-soft" data-id="element-261" data-mp="e8byxupkjnxz">
                That&apos;s less than 25¢ per Field Procedure Card.
              </p>

              <CtaButton href={CHECKOUT_URL} className="mt-4" data-id="element-262" data-mp="16qzd0q65e2pk">
                Get Ice Machine Diagnostic Pro — only $27
              </CtaButton>

              <p className="mt-3 text-xs text-pine-muted" data-id="element-263" data-mp="3f8tny6iy92em">
                Backed by the 7-day money-back guarantee
              </p>

              <ul className="mt-4 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-pine-soft" data-id="element-264" data-mp="359cm606tj8nx">
                <li className="flex items-center gap-1.5" data-id="element-265" data-mp="31892f2lngshf">
                  <LockIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-266" data-mp="319tw6q0547e8" />
                  Secure checkout
                </li>
                <li className="flex items-center gap-1.5" data-id="element-267" data-mp="3syf1v2hw6rfs">
                  <ZapIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-268" data-mp="3t101dkupwvad" />
                  Access in 5 minutes
                </li>
                <li className="flex items-center gap-1.5" data-id="element-269" data-mp="3k7eq4bhrhw5p">
                  <ShieldCheckIcon className="h-4 w-4 text-ember-deep" aria-hidden="true" data-id="element-270" data-mp="3k4she8j4xalw" />
                  7-day guarantee
                </li>
              </ul>
            </div>
          </div>
        </div>

        <p className="mt-4 text-center text-xs text-pine-muted" data-id="element-271" data-mp="1yf50ibflkhz0">
          Price in USD. You&apos;ll be charged the equivalent in your local
          currency.
        </p>
      </div>
    </section>;
}